var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isLoggedIn && !_vm.isAuthServerEnabled
        ? _c(
            "div",
            { staticClass: "forgotten-password ctsform" },
            [
              _c("h1", { key: "fp_ForgotPassword" }, [
                _vm._v(_vm._s(_vm.$t("Account.ForgotPassword.Heading")))
              ]),
              _vm._v(" "),
              _vm.disableForgottenPaswordViaEmail
                ? _c("div", {
                    key: "fp_explanation",
                    staticClass: "no-input",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("Account.ForgotPassword.Body.Disabled")
                      )
                    }
                  })
                : _c("div", {
                    key: "fp_explanation",
                    staticClass: "with-input",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("Account.ForgotPassword.Body"))
                    }
                  }),
              _vm._v(" "),
              !_vm.disableForgottenPaswordViaEmail
                ? _c(
                    "div",
                    {
                      staticClass: "control-block",
                      class: { filled: _vm.username }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.username,
                            expression: "username",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          id: "qa-forgot-password",
                          type: "text",
                          autocomplete: "off",
                          maxlength: 40
                        },
                        domProps: { value: _vm.username },
                        on: {
                          focusout: function($event) {
                            !_vm.forgottenPassDetails.username
                              ? (_vm.errorMessages.username = true)
                              : (_vm.errorMessages.username = false)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.username = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          key: "fp_usernameField_label",
                          staticClass: "control-label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Account.ForgotPassword.Username"))
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _vm.errorMessages.username
                  ? _c(
                      "div",
                      {
                        key: "fp_usernameField_error",
                        staticClass: "vmsg invalid"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.ForgotPassword.ErrorMessages.Username"
                            )
                          )
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "save-container" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        "x-large": "",
                        id: "qa-send-email"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.saveBtnMethod()
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.saveBtnTextKey)))])]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ProcessingDialog",
                {
                  attrs: {
                    isDialogPersistent: true,
                    isProcessing: _vm.isProcessing,
                    isSuccess: !_vm.transactionError,
                    processingTitle: _vm.$t(
                      "Account.ForgotPassword.Dialog.Processing.Title"
                    ),
                    processingText: _vm.$t(
                      "Account.ForgotPassword.Dialog.Processing.Text"
                    ),
                    successTitle: _vm.successTitleText,
                    successText: _vm.$t(
                      "Account.ForgotPassword.Dialog.Success.Text"
                    ),
                    errorTitle: _vm.$t(
                      "Account.ForgotPassword.Dialog.Error.Title"
                    ),
                    closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
                  },
                  model: {
                    value: _vm.dialog,
                    callback: function($$v) {
                      _vm.dialog = $$v
                    },
                    expression: "dialog"
                  }
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "text-error" }, slot: "text-error" },
                    [
                      _vm.brandKey !== "sb"
                        ? _c(
                            "p",
                            { staticClass: "generic-icon-note" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-1",
                                  attrs: { color: "error" }
                                },
                                [_vm._v("error")]
                              ),
                              _c(
                                "span",
                                { attrs: { id: "qa-processingDialogError" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("ProcessingDialog.Error.Text")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "response-error",
                          attrs: { id: "qa-response-error" }
                        },
                        [_vm._v(_vm._s(_vm.transactionError))]
                      ),
                      _vm._v(" "),
                      _c("p", {
                        attrs: { id: "qa-contact-support" },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "Account.CloseAccount.Dialog.Error.Text.ContactSupport"
                            )
                          )
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.brandKey === "sb"
                ? _c("div", {
                    staticClass: "vmsg customersupport",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          "Account.ForgottenPassword.ContactCustomerSupport"
                        )
                      )
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ProcessingDialog",
        {
          attrs: {
            isDialogPersistent: true,
            isProcessing: _vm.isProcessing,
            isSuccess: !_vm.transactionError,
            processingTitle: _vm.$t(
              "Account.ForgotPassword.Dialog.Processing.Title"
            ),
            processingText: _vm.$t(
              "Account.ForgotPassword.Dialog.Processing.Text"
            ),
            successTitle: _vm.successTitleText,
            successText: _vm.$t("Account.ForgotPassword.Dialog.Success.Text"),
            errorTitle: _vm.$t("Account.ForgotPassword.Dialog.Error.Title"),
            closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("div", { attrs: { slot: "text-error" }, slot: "text-error" }, [
            _vm.brandKey !== "sb"
              ? _c(
                  "p",
                  { staticClass: "generic-icon-note" },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "mr-1", attrs: { color: "error" } },
                      [_vm._v("error")]
                    ),
                    _c("span", { attrs: { id: "qa-processingDialogError" } }, [
                      _vm._v(_vm._s(_vm.$t("ProcessingDialog.Error.Text")))
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "response-error",
                attrs: { id: "qa-response-error" }
              },
              [_vm._v(_vm._s(_vm.transactionError))]
            ),
            _vm._v(" "),
            _c("p", {
              attrs: { id: "qa-contact-support" },
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(
                    "Account.CloseAccount.Dialog.Error.Text.ContactSupport"
                  )
                )
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      !_vm.isLoggedIn && _vm.isAuthServerEnabled
        ? _c("div", { staticClass: "forgotten-password ctsform" }, [
            _c("h1", { key: "fp_AccountRecovery" }, [
              _vm._v(_vm._s(_vm.$t("Account.Recovery.Heading")))
            ]),
            _vm._v(" "),
            _vm.disableForgottenPaswordViaEmail
              ? _c("div", {
                  key: "fp_explanation2_no_body",
                  staticClass: "no-input",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("Account.ForgotPassword.Body.Disabled")
                    )
                  }
                })
              : _c("div", { key: "fp_explanation2_with_body" }, [
                  _c("div", {
                    staticClass: "with-input",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("Account.Recovery.Body"))
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "control-block",
                      class: { filled: _vm.username }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.username,
                            expression: "username",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          type: "text",
                          id: "username",
                          autocomplete: "off"
                        },
                        domProps: { value: _vm.username },
                        on: {
                          focusout: function($event) {
                            !_vm.forgottenPassDetails.username
                              ? (_vm.errorMessages.username = true)
                              : (_vm.errorMessages.username = false)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.username = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("Account.Auth.ForgotPassword.Username"))
                        ),
                        _c("span", { staticClass: "control-label-required" }, [
                          _vm._v(" *")
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _vm.errorMessages.username
                      ? _c("div", {
                          staticClass: "vmsg invalid",
                          attrs: { id: "err_msg_username_missing" },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("Account.Auth.Join.ErrorMsg.UserName")
                            )
                          }
                        })
                      : _vm._e()
                  ])
                ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "save-container" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "success", "x-large": "" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.saveBtnMethod()
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.saveBtnTextKey)))])]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20ed78fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20ed78fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountForgottenPassword.vue
// module id = null
// module chunks = 